<template>
<div>
    <header class="header" >
        <nav class="logo">
          <router-link tag="li" to="/Home"><a><img src="../assets/logo.png"></a></router-link>
        </nav>
        <nav class="menu" >
          <ul>
            <router-link tag="li" to="/Home"><a>首 页</a></router-link>
            <router-link tag="li" to="/KeyTech"><a>核心技术</a></router-link>
            <router-link tag="li" to="/ServiceCase"><a>服务领域</a></router-link>
            <!--<router-link tag="li" to="/CustomerCase"><a>客户案例</a></router-link>-->
            <router-link tag="li" to="/Product"><a>产品中心</a></router-link>
            <router-link tag="li" to="/Apply"><a>申请试用</a></router-link>
            <router-link tag="li" to="/NewsList"><a>新闻资讯</a></router-link>
          </ul>
        </nav>
    </header>
    <div class="content"><router-view/></div>
    <footer class="wal" style="clear:both; margin-top: 100px">
        <div class="intro">
          <p>webport@websinda.com</p>
          <!--<a href="mailto:webport@websinda.com" class="email"> <i></i>webport@websinda.com</a>-->
          <p>Copyright 中科新创（北京）科技有限公司</p>
          <p><a target="_blank" href="http://beian.miit.gov.cn">京ICP备18043876号-1</a></p>
        </div>
    </footer>
</div>
</template>

<script>
    export default {
        name: "NavMenu"
    }
</script>

<style scoped>
  .intro p{
    text-align: center;
  }
  .header{
    height: 96px;
    max-width: 1200px;
    margin: 0 auto;
    background-color: #ffffff;
    box-shadow: rgb(220, 219, 219) 0px 0px;
  }
  /*.logo{*/
    /*height: 88px;*/
    /*width: 207px;*/
    /*float: left;*/
  /*}*/
  .logo img{
    height: 65px;
    width: 150px;
    margin: 14px 0;
    float: left;
  }
  .menu{
    /*width: 768px;*/
    height: 96px;
    float: right;
    overflow: hidden
  }
  .menu ul{
    margin: 0 0;
  }
  .menu li {
    width: 112px;
    float: left;
    line-height: 92px;
    color: #262626;
    text-align: center;
  }

  .menu li:hover{
    /*border-top: 1px solid #424C55;*/
    /*background-color: #448ACA;*/
    border-bottom: 4px solid #448ACA;
  }

  .menu li:hover a{
    color: #448ACA;
  }

  .menu a{
    display: block;
    text-decoration: none;
    color: black;
    font-size:16px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:bold;
    /*color:rgba(255,255,255,1);*/
    /*line-height:28px;*/
  }

  .wal {
    position: relative;
    border-bottom: 1px solid #7d7d7d;
    border-top: 1px solid #7d7d7d;
    padding: 1rem;
    height: 1rem;
    max-width: 1200px;
    margin: 25px auto;
  }

  main{
    height:auto;
    display:inline-block !important;
  }
  .is-active a{
    border-bottom: 4px solid #448ACA;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavMenu.vue